import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  employeeRegistration: belongsTo('graphql/employee-registration'),
  entry: belongsTo('graphql/entry'),
  reservation: belongsTo('graphql/reservation'),
  screeningCardable: belongsTo('graphql/screening-cardable', { polymorphic: true }),
  requiredDocumentApprovalExpiresAt: attr('date'),
  requiredDocumentMessage: attr('string'),
  hasRequiredDocumentApproval: attr('boolean'),
});
